export default {
  name: 'CodeGroup',
  data() {
    return {
      codeTabs: [],
      activeCodeTabIndex: -1
    };
  },
  watch: {
    activeCodeTabIndex(index) {
      this.codeTabs.forEach(tab => {
        tab.elm.classList.remove('theme-code-block__active');
      });
      this.codeTabs[index].elm.classList.add('theme-code-block__active');
    }
  },
  mounted() {
    this.codeTabs = (this.$slots.default || []).filter(slot => Boolean(slot.componentOptions)).map((slot, index) => {
      if (slot.componentOptions.propsData.active === '') {
        this.activeCodeTabIndex = index;
      }
      return {
        title: slot.componentOptions.propsData.title,
        elm: slot.elm
      };
    });
    if (this.activeCodeTabIndex === -1 && this.codeTabs.length > 0) {
      this.activeCodeTabIndex = 0;
    }
  },
  methods: {
    changeCodeTab(index) {
      this.activeCodeTabIndex = index;
    }
  }
};